"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeaderBar;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _lodash = require("lodash");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _hamburgerReact = require("hamburger-react");
var _clsx = _interopRequireDefault(require("clsx"));
var _appContext = _interopRequireDefault(require("../../context/appContext"));
var _bookmarkContext = _interopRequireDefault(require("../../context/bookmarkContext"));
var _menuContext = _interopRequireDefault(require("../../context/menuContext"));
var _pageContext = _interopRequireDefault(require("./../../context/pageContext"));
var _userContext = _interopRequireDefault(require("../../context/userContext"));
var _userMenuContext = _interopRequireDefault(require("../../context/userMenuContext"));
var _checkIsTouch = _interopRequireDefault(require("../../utils/checkIsTouch"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
var _languageSwitch = _interopRequireDefault(require("../language-switch"));
var _pagenavigation = _interopRequireDefault(require("../pagenavigation"));
var _menutree = _interopRequireDefault(require("../menutree"));
var _uidrawer = _interopRequireDefault(require("../uidrawer"));
var _usermenu = _interopRequireDefault(require("../usermenu"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => {
  var _theme$palette$backgr, _theme$shadows$, _theme$palette$foregr, _theme$palette$foregr2, _theme$palette$backgr2, _theme$palette$foregr3, _theme$palette$foregr4, _theme$palette$backgr3, _theme$palette$foregr5, _theme$palette$foregr6, _theme$palette$backgr4, _theme$palette$backgr5, _theme$palette$foregr7;
  return {
    root: {
      flexGrow: 1,
      paddingTop: 135
    },
    header: {
      boxShadow: "none",
      padding: "env(safe-area-inset-top) 0 0 0",
      zIndex: theme.zIndex.header
    },
    toolBar: {
      background: (_theme$palette$backgr = theme.palette.background) === null || _theme$palette$backgr === void 0 || (_theme$palette$backgr = _theme$palette$backgr.header) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.appBar,
      boxShadow: (_theme$shadows$ = theme.shadows[25]) === null || _theme$shadows$ === void 0 ? void 0 : _theme$shadows$.header,
      color: (_theme$palette$foregr = (_theme$palette$foregr2 = theme.palette.foreground) === null || _theme$palette$foregr2 === void 0 || (_theme$palette$foregr2 = _theme$palette$foregr2.header) === null || _theme$palette$foregr2 === void 0 ? void 0 : _theme$palette$foregr2.appBar) !== null && _theme$palette$foregr !== void 0 ? _theme$palette$foregr : theme.palette.getContrastText((_theme$palette$backgr2 = theme.palette.background) === null || _theme$palette$backgr2 === void 0 || (_theme$palette$backgr2 = _theme$palette$backgr2.header) === null || _theme$palette$backgr2 === void 0 ? void 0 : _theme$palette$backgr2.appBar),
      display: "grid",
      gridTemplateColumns: "80px 1fr 80px",
      minHeight: 80
    },
    leftColumn: {
      display: "flex"
    },
    rightColumn: {
      display: "flex"
    },
    bookmark: {
      alignItems: "center",
      border: "1px solid ".concat((_theme$palette$foregr3 = (_theme$palette$foregr4 = theme.palette.foreground) === null || _theme$palette$foregr4 === void 0 || (_theme$palette$foregr4 = _theme$palette$foregr4.header) === null || _theme$palette$foregr4 === void 0 ? void 0 : _theme$palette$foregr4.bookmark) !== null && _theme$palette$foregr3 !== void 0 ? _theme$palette$foregr3 : theme.palette.getContrastText((_theme$palette$backgr3 = theme.palette.background) === null || _theme$palette$backgr3 === void 0 || (_theme$palette$backgr3 = _theme$palette$backgr3.header) === null || _theme$palette$backgr3 === void 0 ? void 0 : _theme$palette$backgr3.appBar)),
      borderRadius: "50%",
      color: (_theme$palette$foregr5 = (_theme$palette$foregr6 = theme.palette.foreground) === null || _theme$palette$foregr6 === void 0 || (_theme$palette$foregr6 = _theme$palette$foregr6.header) === null || _theme$palette$foregr6 === void 0 ? void 0 : _theme$palette$foregr6.bookmark) !== null && _theme$palette$foregr5 !== void 0 ? _theme$palette$foregr5 : theme.palette.getContrastText((_theme$palette$backgr4 = theme.palette.background) === null || _theme$palette$backgr4 === void 0 || (_theme$palette$backgr4 = _theme$palette$backgr4.header) === null || _theme$palette$backgr4 === void 0 ? void 0 : _theme$palette$backgr4.appBar),
      cursor: "pointer",
      display: "flex",
      height: theme.spacing(4),
      justifyContent: "center",
      marginRight: theme.spacing(1),
      width: theme.spacing(4)
    },
    badge: {
      "& .MuiBadge-badge": {
        right: 8
      }
    },
    avatar: {
      backgroundColor: (_theme$palette$backgr5 = theme.palette.background) === null || _theme$palette$backgr5 === void 0 || (_theme$palette$backgr5 = _theme$palette$backgr5.header) === null || _theme$palette$backgr5 === void 0 ? void 0 : _theme$palette$backgr5.avatar,
      color: (_theme$palette$foregr7 = theme.palette.foreground) === null || _theme$palette$foregr7 === void 0 || (_theme$palette$foregr7 = _theme$palette$foregr7.header) === null || _theme$palette$foregr7 === void 0 ? void 0 : _theme$palette$foregr7.avatar,
      cursor: "pointer",
      fontSize: 14,
      fontWeight: theme.typography.fontWeightBold,
      height: theme.spacing(4),
      marginRight: theme.spacing(1),
      width: theme.spacing(4)
    },
    logo: {
      display: "flex",
      flexGrow: 1,
      justifyContent: "center"
    },
    menuToggle: {
      color: theme.palette.menuToggle,
      marginLeft: "auto",
      marginRight: -12,
      padding: 0
    }
  };
});
function HeaderBar(props) {
  var _customLinks$find$url, _customLinks$find, _pageData$meta, _theme$palette$backgr6;
  const {
    REACT_APP_LOGO,
    REACT_APP_HEADERLOGOMAXWIDTH,
    REACT_APP_PATH,
    PUBLIC_URL
  } = process.env;
  const {
    title
  } = props;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [appData] = (0, _react.useContext)(_appContext.default);
  const {
    customLinks = []
  } = appData || {};
  const [menuOpen, setMenuOpen] = (0, _react.useContext)(_menuContext.default);
  const [userMenu, setUserMenuOpen] = (0, _react.useContext)(_userMenuContext.default);
  const [pageData] = (0, _react.useContext)(_pageContext.default);
  const [userData] = (0, _react.useContext)(_userContext.default);
  const [bookmarkData] = (0, _react.useContext)(_bookmarkContext.default);
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const theme = (0, _styles.useTheme)();
  const css = useStyles();
  const isTouch = (0, _checkIsTouch.default)();
  const touchURL = (_customLinks$find$url = customLinks === null || customLinks === void 0 || (_customLinks$find = customLinks.find(_ref => {
    let {
      identifier
    } = _ref;
    return identifier === "touch";
  })) === null || _customLinks$find === void 0 ? void 0 : _customLinks$find.url) !== null && _customLinks$find$url !== void 0 ? _customLinks$find$url : "/";

  /**
   * render Avatar
   */

  let avatar = "";
  if (!(0, _lodash.isEmpty)(userData) && userData.state !== 1) {
    const {
      firstname,
      lastname,
      media
    } = userData;
    let chars = "";
    if (firstname) {
      chars = firstname.charAt(0);
    }
    if (lastname) {
      chars += lastname.charAt(0);
    }
    avatar = /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: (0, _clsx.default)({
        [css.avatar]: true
      }),
      alt: firstname + " " + lastname,
      src: media !== null && media !== void 0 && media.filename ? REACT_APP_PATH + media.filename : "",
      onClick: () => setUserMenuOpen(true)
    }, chars);
  } else {
    avatar = /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: css.avatar,
      onClick: () => setUserMenuOpen(true)
    });
  }

  /**
   * render Bookmark
   */

  const bookmark = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: t("site.bookmark.link")
  }, /*#__PURE__*/_react.default.createElement(_core.Badge, {
    badgeContent: bookmarkData.length,
    className: css.badge,
    color: "error",
    overlap: "rectangular"
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: css.bookmark,
    src: "/img/icons/heart.svg",
    size: 16
  })));

  /**
   * render UserMenu
   */

  const uMenu = /*#__PURE__*/_react.default.createElement(_uidrawer.default, {
    open: userMenu,
    setMenuOpen: setUserMenuOpen,
    align: "left",
    fullscreen: false,
    title: !(0, _lodash.isEmpty)(userData) && userData.state !== 1 ? t("site.login.labels.user") : t("site.login.labels.login")
  }, /*#__PURE__*/_react.default.createElement(_usermenu.default, null));

  /**
   * render Logo
   */

  const logo = /*#__PURE__*/_react.default.createElement("div", {
    className: css.logo
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: isTouch ? touchURL : "/".concat(i18n.language, "/")
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxWidth: REACT_APP_HEADERLOGOMAXWIDTH,
      width: "100%",
      display: "block"
    },
    src: PUBLIC_URL + "/img/" + REACT_APP_LOGO,
    alt: ""
  })));

  /**
   * render Hamburger
   */

  const hamburger = /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: css.menuToggle,
    onClick: () => setMenuOpen(!menuOpen),
    "aria-label": "menu"
  }, /*#__PURE__*/_react.default.createElement(_hamburgerReact.Twirl, {
    toggled: menuOpen,
    toggle: setMenuOpen,
    size: 24
  }));

  /**
   * render PageNavigation
   */

  const nav = /*#__PURE__*/_react.default.createElement(_pagenavigation.default, {
    historyBack: true,
    title: title !== null && title !== void 0 ? title : pageData === null || pageData === void 0 || (_pageData$meta = pageData.meta) === null || _pageData$meta === void 0 ? void 0 : _pageData$meta.title
  });

  /**
   * render Menutree
   */

  const tree = /*#__PURE__*/_react.default.createElement(_uidrawer.default, {
    open: menuOpen,
    setMenuOpen: setMenuOpen,
    background: (_theme$palette$backgr6 = theme.palette.background) === null || _theme$palette$backgr6 === void 0 ? void 0 : _theme$palette$backgr6.drawer,
    title: t("site.menu.title"),
    backdropInvisible: false
  }, /*#__PURE__*/_react.default.createElement(_menutree.default, null));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.root
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: css.header,
    position: "fixed"
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: css.toolBar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.leftColumn
  }, isTouch ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: touchURL
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    size: "small",
    variant: "outlined"
  }, t("site.ui.buttons.back"))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, avatar, bookmark, uMenu)), logo, /*#__PURE__*/_react.default.createElement("div", {
    className: css.rightColumn
  }, /*#__PURE__*/_react.default.createElement(_languageSwitch.default, null), hamburger)), nav, tree));
}